import * as actionTypes from './actionTypes';

export const initCellular = () => {
  return { type: actionTypes.INIT_CELLULAR };
};

export const setCellular = (cellularData) => {
  return { type: actionTypes.SET_CELLULAR, cellularData };
};

export const fetchCellularFailed = () => {
  return { type: actionTypes.FETCH_CELLULAR_FAILED };
};
